import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {createBindItemByTemplate} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/0->1-migration';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {serialize} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

const MIGRATED_VERSION:DesignerVersion = 6;

export const migration_5_6:IMigration = {
    from: 5,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === 5);

        console.log('migration 5->6 designState', designState);

        if( designState.surface && designState.surface.artboard && designState.surface.artboard.allBoxes )
            Object.values(designState.surface.artboard.allBoxes).forEach((boxSnapshot:any) =>
            {
                const {componentDesc} = boxSnapshot;
                const repeaterPropSnapshot:any = Object.values(componentDesc._baseProperties).find(
                    (propSnapshot:any) => propSnapshot.name === 'repeater'
                );
                const mainBindGroup:any = Object.values(repeaterPropSnapshot._bindGroups).find(
                    (bindGroupSnapshot:any) => bindGroupSnapshot.name === 'main'
                );
                const repeaterPropConfig:any = SystemPropsConfigs.basePropertiesConfigs.get(SystemPropsConfigs.REPEATER_PROP_NAME);
                const mainBindItemTemplate:any = repeaterPropConfig.bindGroupsTemplates.get('main');

                const offsetBindGroupItem:any = createBindItemByTemplate(
                    mainBindItemTemplate.paths.get('offset'),
                    serialize(AInteger.fromNumber(1)),
                    mainBindGroup.rootBindItem.id
                );

                const limitBindGroupItem:any = createBindItemByTemplate(
                    mainBindItemTemplate.paths.get('limit'),
                    null,
                    mainBindGroup.rootBindItem.id
                );

                mainBindGroup.rootBindItem.paths[0][offsetBindGroupItem.id] = offsetBindGroupItem;
                mainBindGroup.rootBindItem.paths[0][limitBindGroupItem.id] = limitBindGroupItem;

                const typeBindGroupItem:any = Object.values(mainBindGroup.rootBindItem.paths[0]).find(
                    (bindGroupItemSnapshot:any) => bindGroupItemSnapshot.path === 'type'
                );

                if( typeBindGroupItem )
                    delete mainBindGroup.rootBindItem.paths[0][typeBindGroupItem.id];
            });

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
